package top.wcpe.allincore.dsl.compiler.codegen

import top.wcpe.allincore.dsl.compiler.ast.FunDecl
import top.wcpe.allincore.dsl.compiler.codegen.internal.ExprSerializer
import top.wcpe.allincore.dsl.ir.model.action.IrFun

/**
 * 把 [FunDecl] 转换为 [IrFun]：保留参数名 + 复用 action body 字节布局序列化 body。
 *
 * M5-b：把 [FunDecl.defaults] 中每个非空默认值表达式独立序列化为 expr blob，
 * 与 params 同位置组成 defaultBlobs；defaults 为空（全部无默认值）时传空列表。
 */
class FunEmitter {

    fun emit(decl: FunDecl): IrFun {
        val defaults = decl.defaults
        val defaultBlobs: List<ByteArray?> = if (defaults.isEmpty()) {
            emptyList()
        } else {
            require(defaults.size == decl.params.size) {
                "FunDecl '${decl.name}' defaults 长度 ${defaults.size} 与 params 长度 ${decl.params.size} 不一致"
            }
            defaults.map { def -> def?.let { ExprSerializer.serializeExpr(it) } }
        }
        return IrFun(
            decl.name,
            decl.params,
            ExprSerializer.serializeActionBody(decl.body),
            defaultBlobs,
        )
    }
}
